import script from "./OSSpoofingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OSSpoofingModal.vue?vue&type=script&setup=true&lang=js"

import "./OSSpoofingModal.vue?vue&type=style&index=0&id=2089d55c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2089d55c"]])

export default __exports__